export const componentStyles = {
  sectionDesign: {
    background: "linear-gradient(270deg, #EBD6E2 0%, #F3DADC 50%, #E1EBED 100%)",
    borderRadius: "50px",
    minHeight: "470px",
    width: "120vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "2rem 0",
    overflow: "hidden"
  },
  sectionDesign2: {
    background: "linear-gradient(270deg, #235877   0%, #377B85  40%, #408A79 100%)",
    borderRadius: "50px",
    minHeight: "470px",
    width: "120vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "2rem 0",
    overflow: "hidden"
  },

  logoPadding: {
    '@media (max-width: 768px)': {
      paddingLeft: "0%",
      textAlign: "center",
    },
  },

  largeImage: {
    width: "401px",
    height: "401px",
    maxWidth: "401px",
    objectFit: "cover",
    borderRadius: "50%", 
    '@media (max-width: 768px)': {
      maxWidth: "401px",
      width: "300px",
      height: "300px", 
    },
  },
};
